import { AbschnittDisplayModel, LocalizedTextDisplayModel } from '@/api/model-index';
import { Injectable } from '@angular/core';
import { NavigationItem } from '../models/navigation-item.model';
import { FormularService } from './formular.service';
import { I18nService } from './i18nService';

@Injectable({
    providedIn: 'root'
})
export class NavigationService
{
    constructor(
        public formularService: FormularService,
        public languageService: I18nService
        ) {
        // ...
    }

    public getNavItems(abschnitte: AbschnittDisplayModel[] | null | undefined): NavigationItem[] | null {
        let navItems: NavigationItem[] = [];
    
        if (abschnitte) {
            abschnitte.forEach(abschnitt => {
                let item = this.getNavItem(abschnitt);
                if (item)
                    navItems.push(item);
            });
        }
        return navItems;
      }
    
      public getNavItem(abschnitt: AbschnittDisplayModel): NavigationItem | null {
        if (abschnitt.formularTyp == undefined)
            return null;
    
        let navItem: NavigationItem = this.formularService.getRouteObjectThrough(abschnitt);
        navItem.abschnitt = abschnitt;
        navItem.childAbschnitte = abschnitt.abschnitte ?? [];
        let defaulttext = new LocalizedTextDisplayModel();
        defaulttext.localeCode = this.languageService.language;
        defaulttext.text = abschnitt.name?? ""
        navItem.name = abschnitt.kurzTitel ?? [defaulttext];
        navItem.formularTyp = abschnitt.formularTyp;
        return navItem;
      }   
}
